import { months } from "moment";
import React from "react";

import "./PrintTemplate.css";
import { useTranslation } from "react-i18next";

interface Props {
  toningData: any;
}

const translationPrefix = 'Printing';

const PrintTemplateA4 = (props: Props) => {
  const getFormattedDate = () => {

    var date = new Date();
    var month = date.getMonth() + 1;
    var formattedMonth = month < 10 ? `0${month}` : month;
    var year = date.getFullYear();
    var day = date.getDate();
    var formattedDay = day < 10 ? `0${day}` : day;

    return `${formattedDay}.${formattedMonth}.${year}`;
  }

  const { t } = useTranslation(undefined, { keyPrefix: translationPrefix });
  debugger;
  return (
    <div className="printContainer">
      <div className="row headlineRow">
        <div className="col-6">
          <h2 className="printHeadline boldedText">{t('ReceiptWithSystemInfo')}</h2>
        </div>
        <div className="col-6 rightAlignment">
          <h2 className="printHeadline">{`${t('IssueDate')}: ${getFormattedDate()}`}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-3">
          <span className="printLabel">{t('SampleBook')}</span>
        </div>
        <div className="col-9 boldedText printValue">
          {props.toningData.sampleCardName}
        </div>
      </div>
      <div className="row">
        <div className="col-3">
          {t('Color')}
        </div>
        <div className="col-9 boldedText printValue">
          {props.toningData.colorName}
        </div>
      </div>
      {/*
      <div className="row">
        <div className="col-3">
          {t('Product')}
        </div>
        <div className="col-9 boldedText printValue">
          {props.toningData.productName}
        </div>
      </div>
      */}
      <div className="row">
        <div className="col-3">
          {t('Base')}
        </div>
        <div className="col-9 boldedText printValue">
          {props.toningData.baseName}
        </div>
      </div>
      {/*
      <div className="row">
        <div className="col-3">
          {t('Package')}
        </div>
        <div className="col-9 boldedText printValue">
          {props.toningData.formattedBaseVolumeKg}
        </div>
      </div>
*/}
      <div className="row receiptHeader">
        <div className="col-12">
          {t('Receptura')}
        </div>
      </div>

      <div className="row receiptHeaderForHardeners">
        <div className="col-12">
          <table className="printPigmentsTable">
            <thead >
              <tr>
                <th style={{ fontWeight: 'bold', width: '35%' }}>
                  {t('Product')}
                </th>
                <th style={{ fontWeight: 'bold' }}>
                  {t('Amount')} ({`${props.toningData.pigments[0].unitCode == 'Oz' ? 'ml' :
                    props.toningData.pigments[0].unitCode.toLowerCase()}`})
                </th>
                <th style={{ fontWeight: 'bold', width: '30%' }}>
                  {t('Price')}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{props.toningData.productName}</td>
                <td className="rightAlignment">{props.toningData.formattedBaseVolume}</td>
                <td className="rightAlignment printPrice">{props.toningData.formattedBasePrice}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {props.toningData && props.toningData.pigments && props.toningData.pigments.length > 0 &&
        <div className="row receiptHeader">
          <div className="col-12">
            <table className="printPigmentsTable">
              <thead >
                <tr>
                  <th style={{ fontWeight: 'bold', width: '35%' }}>
                    {t('Pigment')}
                  </th>
                  <th style={{ fontWeight: 'bold' }}>
                    {t('Amount')} ({`${props.toningData.pigments[0].unitCode == 'Oz' ? 'ml' :
                      props.toningData.pigments[0].unitCode.toLowerCase()}`})
                  </th>
                  {(props.toningData.pigments[0].unitCode == 'Oz' || props.toningData.yFormatIsActive) &&
                    <th style={{ fontWeight: 'bold' }}>
                      {t('Amount')} ({props.toningData.yFormatIsActive ? 'y+oz' : props.toningData.pigments[0].unitCode.toLowerCase()})
                    </th>
                  }
                  <th style={{ fontWeight: 'bold', width: '30%' }}>
                    {t('Price')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {props.toningData && props.toningData.pigments && props.toningData.pigments.length > 0 &&
                  props.toningData.pigments.map((pigment: any) => {
                    return <tr>
                      <td>{pigment.name}</td>
                      {(pigment.unitCode == 'Oz' || props.toningData.yFormatIsActive) && <>
                        <td className="rightAlignment">{pigment.formattedAmountInMl}</td>
                        {props.toningData.yFormatIsActive && <td className="rightAlignment">{pigment.formattedAmountInYFormat}</td>}
                        {!props.toningData.yFormatIsActive && <td className="rightAlignment">{pigment.formattedAmountInUnit}</td>}
                      </>}
                      {pigment.unitCode != 'Oz' && !props.toningData.yFormatIsActive && <td className="rightAlignment">{pigment.formattedAmountInUnit}</td>}
                      <td className="rightAlignment printPrice">{pigment.formattedPrice}</td>
                    </tr>
                  })
                }
              </tbody>
              <tfoot>
                <tr style={{ borderTop: '1px solid black', fontWeight: 'bold' }}>
                  <td className="boldedText">{t('Amount')}</td>
                  {(props.toningData.pigments[0].unitCode == 'Oz' || props.toningData.yFormatIsActive) &&
                    <td className="boldedText rightAlignment">{props.toningData.formattedPigmentsVolumeMl}</td>
                  }
                  <td className="boldedText rightAlignment">{props.toningData.formattedPigmentsVolume}</td>
                  <td className="boldedText rightAlignment">{props.toningData.formattedPigmentsPrice}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      }

      <div className="row receiptHeaderForTonedProduct">
        <div className="col-12">
          <table className="printPigmentsTable">
            <thead >
              <tr>
                <th colSpan={3} style={{ fontWeight: 'bold' }}>
                  {`${t('TonedProduct')} (${t('BaseAndPigment')})`}
                </th>

              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ fontWeight: 'bold', width: '35%' }}>{t('Amount')}</td>
                <td style={{ fontWeight: 'bold', width: '35%' }} className="rightAlignment">{props.toningData.formattedVolumeBaseAndPigments}</td>
                <td style={{ fontWeight: 'bold', width: '30%' }} className="rightAlignment printPrice">{props.toningData.formattedTotalPriceWithoutHardenersWithoutVAT}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {props.toningData && props.toningData.hardeners && props.toningData.hardeners.length > 0 &&
        <div className="row receiptHeaderForHardeners">
          <div className="col-12">
            <table className="printHardenersTable">
              <thead >
                <tr>
                  <th style={{ fontWeight: 'bold', width: '35%' }}>
                    {t('Hardener')}
                  </th>
                  <th style={{ fontWeight: 'bold' }}>
                    {t('Amount')}
                  </th>
                  <th style={{ fontWeight: 'bold', width: '30%' }}>
                    {t('Price')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {props.toningData && props.toningData.hardeners && props.toningData.hardeners.length > 0 &&
                  props.toningData.hardeners.map((hardener: any) => {

                    return <tr>
                      <td>{hardener.name}</td>
                      {hardener.unitCode == 'Oz' && <>
                        <td className="rightAlignment">{hardener.formattedAmountInMl}</td>
                        {props.toningData.yFormatIsActive && <td className="rightAlignment">{hardener.formattedSize}</td>}
                        {!props.toningData.yFormatIsActive && <td className="rightAlignment">{hardener.formattedSize}</td>}
                      </>}
                      {hardener.unitCode != 'Oz' && <td className="rightAlignment">{hardener.formattedSize}</td>}
                      <td className="rightAlignment printPrice">{hardener.formattedPrice}</td>
                    </tr>
                  })
                }
              </tbody>
              <tfoot>
                <tr style={{ borderTop: '1px solid black', fontWeight: 'bold' }}>
                  <td className="boldedText">{t('Amount')}</td>
                  {props.toningData.hardeners[0].unitCode == 'Oz' &&
                    <td className="boldedText rightAlignment">{props.toningData.formattedHardenersVolumeMl}</td>
                  }
                  <td className="boldedText rightAlignment">{props.toningData.formattedHardenersVolume}</td>
                  <td className="boldedText rightAlignment">{props.toningData.formattedHardenersPrice}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      }

      <div className="row receiptHeaderForHardeners">
        <div className="col-12">
          <table className="printPigmentsTable">

            <tbody>
              <tr>
                <td style={{ fontWeight: 'bold', width: '35%' }}>{t('TotalAmount')}</td>
                <td style={{ fontWeight: 'bold', width: '35%' }} className="rightAlignment">{props.toningData.formattedVolume}</td>
                <td style={{ fontWeight: 'bold', width: '30%' }} className="rightAlignment">{props.toningData.formattedPackagePriceWithoutVAT}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="row" style={{ marginTop: '1rem' }}>
        <div className="col-6">
          <div className="row">
            <div className="col-6 printNormalText">{t('BasePrice')}</div>
            <div className="col-6 printNormalText rightAlignment">{props.toningData.formattedBasePrice}</div>
          </div>
          <div className="row">
            <div className="col-6 printNormalText">{t('PigmentsPrice')}</div>
            <div className="col-6 printNormalText rightAlignment">{props.toningData.formattedPigmentsPrice}</div>
          </div>
          <div className="row">
            <div className="col-6 printNormalText">{t('PackagePrice')}</div>
            <div className="col-6 printNormalText rightAlignment">{props.toningData.formattedPackagePriceWithoutVAT}</div>
          </div>
        </div>
        <div className="col-6">
          <div className="row">
            <div className="col-6 printNormalText">{t('EnteredBy')}</div>
            <div className="col-6 printNormalText rightAlignment">{props.toningData.currentUserName}</div>
          </div>
          <div className="row">
            <div className="col-6 printNormalText">{t('Date')}</div>
            <div className="col-6 printNormalText rightAlignment">{getFormattedDate()}</div>
          </div>
          <div className="row">
            <div className="col-6 printNormalText">{t('Customer')}</div>
            <div className="col-6 rightAlignment"></div>
          </div>
        </div>

      </div>

      <div className="row" style={{ marginTop: '2rem' }}>
        <div className="col-6">
          <div className="row">
            <div className="col-6 printNormalText">{t('CountOfPackages')}</div>
            <div className="col-6 printNormalText rightAlignment">{props.toningData.numberOfPackages}</div>
          </div>
          {props.toningData.discount && props.toningData.discount.length > 0 &&
            <div className="row">
              <div className="col-6 printNormalText">{t('Discount')}</div>
              <div className="col-6 printNormalText rightAlignment">{props.toningData.discount}</div>
            </div>
          }
          <div className="row">
            <div className="col-6 printNormalText">{t('TotalPriceWithoutVAT')}</div>
            <div className="col-6 printNormalText rightAlignment">{props.toningData.formattedTotalPriceWithoutVAT}</div>
          </div>
          <div className="row" style={{ fontWeight: 'bold' }}>
            <div className="col-6 printNormalText">{t('TotalPriceWithVAT')}</div>
            <div className="col-6 printNormalText rightAlignment ">{props.toningData.formattedTotalPriceWithVAT}</div>
          </div>

          <div className="row" style={{ marginTop: '2rem' }}>
            <div className="col-12 printNormalText">{t('Note')}<br />{props.toningData.noteExternal}</div>
          </div>
        </div>
        <div className="col-6 centered">
          <div style={{ border: '2px solid black', height: '200px', width: '100%' }}>

          </div>
          <span className="boldedText printNormalText">{t('TestingDrawOfReceipt')}</span>
          <div style={{ border: '2px solid black', width: '100%', marginTop: '3rem' }}></div>
          <span className="printNormalText" style={{ fontWeight: 'bold' }}>{t('MixedBy')}</span>
        </div>
      </div>
    </div>
  );
}

export default PrintTemplateA4;
